<template>
  <div id="header-desktop">
    <TheSiteLogo />
    <TheSearchBar />
    <TheNavigation />
    <TheTools />
  </div>
</template>

<script>
import TheSiteLogo from '@/components/common/TheSiteLogo.vue';
import TheSearchBar from '@/components/common/TheSearchBar.vue';
import TheNavigation from '@/components/common/TheNavigation.vue';
import TheTools from '@/components/common/TheTools.vue';

export default {
  name: 'AppHeaderDesktop',

  components: {
    TheSiteLogo,
    TheSearchBar,
    TheNavigation,
    TheTools,
  },
};
</script>

<style lang="scss" scoped>
  #header-desktop {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>
